import { connect } from 'react-redux';
import { IState } from '../../store';

import { ISharingProps, Sharing } from './index';
import { shareTitleSelector } from '../../selectors/shareTitleSelector';

export function mapStateToProps(state: IState): ISharingProps {
  return {
    offerData: Object.assign({}, state.offerData),
    pageData: state.pageData,
    title: shareTitleSelector(state, true),
  };
}

export const SharingContainer = connect<ISharingProps, {}>(mapStateToProps)(Sharing);
